// eslint-disable-next-line import-x/order
import { assertConfig } from 'config';
// eslint-disable-next-line import-x/order
import { initDatadogRum } from 'datadog-rum';
// RUM first, so a config failure is reported rather than just thrown.
initDatadogRum();
assertConfig();
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { AppContext } from 'components/app/app-context';
import { AppRoot } from 'components/app/app-root';
import { AppRoutes } from 'components/app/app-routes';
import 'posthog';
import './index.css';
// eslint-disable-next-line import-x/no-named-as-default-member
ReactDOM.render(React.createElement(AppContext, null,
    React.createElement(BrowserRouter, null,
        React.createElement(AppRoot, null,
            React.createElement(AppRoutes, null)))), document.getElementById('root'));
